import Vue from 'vue';

export default Vue.component('section-slantright-divider', {
  template: require('./template.html'),
  name: 'section-slantright-divider',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/shape-dividers/slant-right/index.js